<ng-container *transloco="let t">
  <div class="owner-statement-treatment">
    <div [formGroup]="form">
      <h3 class="mb-2">{{ t('SAGLASNOST ZA LEČENJE / POSTUPAK') }}</h3>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('Anamnesis') }}</mat-label>
        <textarea matInput formControlName="anamnesis" rows="4"></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('Clinical findings') }}</mat-label>
        <textarea
          matInput
          formControlName="clinicalFinding"
          rows="4"
        ></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('Therapy') }}</mat-label>
        <textarea matInput formControlName="therapy" rows="4"></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('Recommendation') }}</mat-label>
        <textarea matInput formControlName="recommendation" rows="4"></textarea>
      </mat-form-field>
      <h4 class="mb-1">
        {{ t('Veterinar je savetovao i objasnio sledeće') }}
      </h4>
      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('Select items') }}</mat-label>
        <mat-select formControlName="explainedItems" multiple>
          <mat-option
            [value]="
              t('General nature of the proposed treatments / procedures.')
            "
            >{{
              t('General nature of the proposed treatments / procedures.')
            }}</mat-option
          >
          <mat-option
            [value]="
              t('Expected benefits of the stated treatment / procedures.')
            "
            >{{
              t('Expected benefits of the stated treatment / procedures.')
            }}</mat-option
          >
          <mat-option
            [value]="
              t(
                'Reasonable risks or hazards and side effects of the stated treatment / procedures.'
              )
            "
            >{{
              t(
                'Reasonable risks or hazards and side effects of the stated treatment / procedures.'
              )
            }}</mat-option
          >
          <mat-option
            [value]="
              t(
                'Reasonable alternative courses of action and risks/benefits of each are available.'
              )
            "
            >{{
              t(
                'Reasonable alternative courses of action and risks/benefits of each are available.'
              )
            }}</mat-option
          >
          <mat-option
            [value]="
              t('Consequences if the treatment / procedure is not carried out.')
            "
            >{{
              t('Consequences if the treatment / procedure is not carried out.')
            }}</mat-option
          >
          <mat-option
            [value]="
              t(
                'Other veterinarians may also provide some of the treatments and care for the animal.'
              )
            "
            >{{
              t(
                'Other veterinarians may also provide some of the treatments and care for the animal.'
              )
            }}</mat-option
          >
          <mat-option [value]="t('Costs of the treatment / procedure.')">{{
            t('Costs of the treatment / procedure.')
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <h4 class="mb-1">
        {{ t('Podaci za kontakt u slučaju da vlasnik nije dostupan') }}
      </h4>
      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('Ime i prezime') }}</mat-label>
        <input matInput formControlName="proxyName" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('Telefon') }}</mat-label>
        <input matInput formControlName="proxyPhone" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('veterinarianName') }}</mat-label>
        <input matInput formControlName="veterinarianName" />
        <mat-error>{{ t('This field is required') }}</mat-error>
      </mat-form-field>
    </div>
  </div>
</ng-container>
